export default "__VITE_ASSET__fGfbT1dR__"